
      import Attachment from './attachment.vue'
      import type { App, Plugin } from 'vue'

      export const AttachmentPlugin: Plugin = {
        install(app: App) {
          app.component('Attachment', Attachment)
        },
      }
      export { Attachment }
      